export default __webpack_public_path__ + "static/media/blackCard.f016ba2a.svg";